import { Component, input } from '@angular/core';
import {
  AbstractControlDirective,
  AbstractControl,
} from '@angular/forms';
@Component({
  selector: 'app-validation-errors',
  template: `
   @if (shouldShowErrors()) {
     <small class="text-danger validation-error">{{getError()}}</small>
   }
   `,
  imports: []
})

export class ValidationErrorsComponent {

  private static readonly errorMessages = {
    'required': (params) => '##FIELD## is required.',
    'min': (params) => 'Minimum allowed value for ##FIELD## is ' + parseInt(params.min, 10),
    'max': (params) => 'Maximum allowed value for ##FIELD## is ' + params.max,
    'minlength': (params) => '##FIELD## should be minimum ' + params.requiredLength + ' characters.',
    'maxlength': (params) => '##FIELD## should not be greater than ' + params.requiredLength + ' characters.',
    'pattern': (params) => '##FIELD## should be a valid',
    'email': (params) => 'Invalid email.',
    'validateNumber': (params) => 'Should be valid number.',
    'validateEmail': (params) => 'Should be vaild email.',
    'owlDateTimeMin': (params) => ' ##FIELD##  is invalid ',
    'owlDateTimeParse': (params) => 'Invalid Date Time value.',
    'noWhitespace': (params) => '##FIELD## should not have whitespace.',
    'validatePricingField': (params) => '##FIELD## should have only number or "+".',
    'invalidPassword': (params) => '##FIELD## requires minimum 5 characters, must include at least 1 number and 1 special character.',
    'invalidAmount': (params) => '##FIELD## allows a maximum of 5 digits before the decimal point and 3 digits after the decimal point.',
    'url': (params) => 'Invalid ##FIELD##',
    'maxQty': (params) => 'Total ##FIELD## available is ' + params.maxQty,
    'incorrectPassword': (params) => 'Current Password is incorrect',
    'sameAsCurrent': (params) => 'New Password cannot be same as Current Password',
    'mismatchedPasswords': (params) => 'Passwords do not match',
    'stateDoesntMatch': (params) => 'State and Zip Code doesnot match',
    'passwordComplexity': (params) => 'Must contain letters and numbers.',
    'passwordLength': (params) => 'Must be at least 12 characters long.',
    'passwordCase': (params) => 'Must contain both upper and lower-case letters.',
    'passwordSpecialChar': (params) => 'Must contain at least one special character.',
  };

  readonly control = input<AbstractControlDirective | AbstractControl>(undefined);

  readonly submitted = input<boolean>(undefined);
  readonly fieldName = input<string>(undefined);

  public shouldShowErrors(): boolean {
    const control = this.control();
    return control && control.errors && (control.dirty || control.touched || this.submitted());
  }

  public listOfErrors(): string[] {
    return Object.keys(this.control().errors).map(field => this.getMessage(field, this.control().errors[field], this.control()));
  }

  public getError(): string {
    const errors = Object.keys(this.control().errors).map(field => this.getMessage(field, this.control().errors[field], this.control()));
    return errors[0];
  }

  private getMessage(type: string, params: any, control: any) {
    let fname = '';
    fname = this.getControlName(control);
    if (!this.fieldName()) {
      fname = fname.replace(new RegExp('_', 'g'), ' ');
      fname = fname.replace(' id', '').toLowerCase();
      fname = fname.replace(/\b\w/g, l => l.toUpperCase());
    }
    if (ValidationErrorsComponent.errorMessages[type]) {
      const msg = ValidationErrorsComponent.errorMessages[type](params);
      return msg.replace('##FIELD##', fname);
    }

    return '';
  }

  public getControlName(c: AbstractControl): string | null {
    const fieldName = this.fieldName();
    if (fieldName && fieldName !== '') {
      return fieldName;
    }
    const formGroup = c.parent.controls;
    return Object.keys(formGroup).find(name => c === formGroup[name]) || null;
  }

}
